module.exports = __webpack_public_path__ + "img/next-manual.4d115cae.png";